module.exports = __webpack_public_path__ + "img/avatar-82.c45bf208.png";